import { getFeatureConfig } from '@luna/feature-config';

export function getAmountInputValue(value?: number): number | undefined {
    if (value !== 0) {
        return value;
    }
    return undefined;
}

export function getAmountInputPlaceholder(
    precision: number,
    symbol = '0',
    decimalSeparator = getFeatureConfig((features) => features.base.decimalSeparator),
): string {
    if (precision === 0) {
        return symbol;
    }

    const decimalPlaces = symbol.padStart(precision, symbol);

    return `${symbol}${decimalSeparator}${decimalPlaces}`;
}
